/* eslint-disable no-console */
import t from './ProductCP.type';
import * as oprationalcp from '../../../services/oprationalcp.service';
import * as productcp from '../../../services/productcp.service';
import { getUserSuppliers } from '../../../services/supplierSuggestion.service';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { HTTP_STATUS } from '../../../constants/api-status-codes';

export const addProductCard = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.addProductCard(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return null;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchUnArchiveCardData = (params) => async (dispatch) => {
  try {
    const res = await productcp.fetchAllProductCards(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_UNARCHIVED_CARDS,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getIndividualDetails = (params) => async (dispatch) => {
  try {
    const res = await productcp.fetchProductDetail(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_INDIVIDUAL_DETAILS,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducerTab = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_TABS,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_REDUCER,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearIndividualReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_INDIVIDUAL_REDUCER,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSuppliers = (params) => async (dispatch) => {
  try {
    const res = await oprationalcp.fetchAllSuppliers(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_SUPPLIERS,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

/**
 * Fetches suppliers scoped to the logged-in user's UserGroups access (brand/category/supplier restrictions), unlike fetchSuppliers which returns every company supplier.
 * @returns {Function}
 */
export const fetchScopedSuppliers = () => async (dispatch) => {
  try {
    const res = await getUserSuppliers();
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_SUPPLIERS,
        payload: res.data?.suppliers || [],
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCard = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.deleteProductCP(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const duplicateProductCard = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.duplicateProductCard(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return null;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchTabColumnDataforPCP = (params, fromSave) => async (dispatch) => {
  try {
    const result = await productcp.fetchDynamicTabColumnDetails(params);
    if (result.success && result.statusCode === HTTP_STATUS.OK) {
      const res = result.data;
      if (res?.code === 200) {
        if (fromSave) {
          await dispatch({
            type: t.GET_NEW_CALCULATION,
            payload: res.data,
          });
          return res;
        }
        await dispatch({
          type: t.GET_ALL_TAB_COLUMDATA,
          payload: res.data,
        });
        await dispatch({
          type: t.GET_ALL_TAB_COLUMDATA,
          payload: res.data,
        });
        return res;
      }
      toasterMsg(res?.data?.errMsg?.toString() ?? 'Request failed', 'danger');
      return res;
    }
    if (!result.success) {
      const body =
        typeof result.data === 'string'
          ? (() => {
              try {
                return JSON.parse(result.data);
              } catch {
                return {};
              }
            })()
          : result.data ?? {};
      const errMsg = body?.data?.errMsg ?? body?.message;
      let msg = errMsg ?? 'Something went wrong. Please try again.';
      if (result.statusCode === HTTP_STATUS.NOT_FOUND) msg = 'PCP not found';
      else if (result.statusCode === HTTP_STATUS.BAD_REQUEST) msg = errMsg ?? 'Bad request';
      toasterMsg(msg, 'danger');
    }
    return result.data;
  } catch (err) {
    const apiMsg = err?.response?.data?.data?.errMsg ?? err?.response?.data?.message;
    toasterMsg(apiMsg ?? err?.message ?? err?.toString?.() ?? 'Request failed', 'danger');
  }
};

export const getAllProductcpTabs = (params) => async (dispatch) => {
  try {
    const res = await productcp.getAllProductcpTabsService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.ALL_PRODUCTCP_TABLIST,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addProductCpTabs = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await productcp.addProductCpTabsService(data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg(res.message.toString()), 'success');
      await dispatch(getAllProductcpTabs({ productCPId: data.productCPId }));
    } else {
      toasterMsg(transactionMsg(res.data.errMsg.toString()), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addColumnsToProductCpCard = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.addColumnsToProductCpCardService(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteTabsColumns = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.deleteTabsColumnsService(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const activeInactiveAction = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.activeInactiveActionService(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const insertManualData = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.manualDataAdded(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const insertManualDataPO = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.manualDataAddedPO(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updatePCPDetailBySupplier = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.updatePCPDetailBySupplier(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    toasterMsg(res?.data?.errMsg || transactionMsg('PRODUCT_CP.UPDATE_FAILED'), 'danger');
    return null;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return null;
  }
};

// rearrange tabs
export const rearrangeTabs = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.rearrangeTabChanges(params);
    if (res && res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// deleteTabs from PCP
export const deletePCPTabs = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.deleteTabsPCP(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadPCPExcel = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.downloadPCPExcelService(params); // API
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`PRODUCT_CP.${res?.data?.errMsg}`), 'danger');
    }
    return res;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
  return true;
};

export const getPCPLogs = (params) => async (dispatch) => {
  try {
    const res = await productcp.getPCPLogs(params); // API
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.GET_PCP_LOGS,
        payload: res.data,
      });
      return true;
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const clearPCPLogs = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_LOGS_REDUCER,
    });
  } catch (err) {
    console.log('............', err);
  }
};

export const deletePCPLogs = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.deletePCPLogs(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`RANGE_PLAN.${res?.data?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

// bulk update in CP
export const bulkUpdatePCP = (params, transactionMsg) => async () => {
  try {
    const res = await productcp.bulkUpdateServices(params);
    if (res && res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return false;
  }
};

export const pinUnpinTabColum = (data, transactionMsg) => async () => {
  try {
    const res = await productcp.pinUnpinTabColum(data);
    if (res && res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_CP.${res.data}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getTabColumns = (params) => async (dispatch) => {
  try {
    const res = await productcp.getTabColumn(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_TAB_COLUMNS,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const getColumFilterData = (params) => async (dispatch) => {
  try {
    const res = await productcp.fetchColumnFilter(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_COLUMN_FILTER,
        payload: res.data,
      });
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducerTableDetails = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_TABLE_REDUCER,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const uploadPCPFileToS3 = (file, pcpId, basedOnPO) => {
  return async () => {
    try {
      const isProductBased = basedOnPO === false;
      const getPresignedUrl = isProductBased ? productcp.getPCPProductUploadPresignedUrl : productcp.getPCPUploadPresignedUrl;
      const urlResponse = await getPresignedUrl(pcpId, file.name);

      if (urlResponse?.code !== 200 || !urlResponse?.data?.presignedUrl) {
        return {
          success: false,
          message: urlResponse?.message || 'Failed to get upload URL',
        };
      }

      const { presignedUrl, s3Key } = urlResponse.data;

      const uploadResponse = await productcp.uploadFileToS3Direct(presignedUrl, file);

      if (!uploadResponse.success) {
        return {
          success: false,
          message: 'Failed to upload file to S3',
        };
      }

      return {
        success: true,
        s3Key,
        message: 'File uploaded successfully',
      };
    } catch (err) {
      console.error('uploadPCPFileToS3 error:', err);
      return {
        success: false,
        message: err.message || 'Upload failed',
      };
    }
  };
};
